













import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import WelcomeMessageEditor from "@/components/WelcomeMessageEditor";

export default defineComponent({
  name: "FollowingSettingsView",
  components: { BasePage, PageTitle, WelcomeMessageEditor },
  props: {
    subjectId: { type: String, required: true },
  },
});
